<script>
import { useContactFormValidation } from "~/composables/useContactFormValidation";
import { nextTick } from "vue";

export default {
  name: "FooterContact",

  data() {
    return {
      selectedOption: null
    };
  },

  setup() {
    const { form, errors, validateForm } = useContactFormValidation();

    function handleSubmit(e) {
      e.preventDefault();

      if (!validateForm()) return;

      // set defaults in Vue state only
      Object.keys(this.form).forEach((key) => {
        const value = this.form[key];

        if (value == "" || value == null || value === undefined) {
          const el = e.target.querySelector(`[name*="${key}"]`);
          if (!el) return;

          const fallback = el.getAttribute("data-empty");
          if (!fallback) return;

          // IMPORTANT: keep correct type for selects
          this.form[key] = el.type === "select-one"
            ? fallback
            : fallback;
          el.value = fallback;
        }
      });

      nextTick(() => {
        e.target.submit();
      });
    }

    return {
      form,
      errors,
      handleSubmit,
    };
  },

  methods: {
    handleSelectChange(event) {
      this.selectedOption = event.target.value;

      const fields = this.$el.querySelectorAll("[data-show-on]");

      fields.forEach((field) => {
        var showOnItems = field.dataset.showOn.split('|');
        var show = false;

        if (showOnItems.length) {
          for (let showOn of showOnItems) {
            if (showOn === this.selectedOption) {
              show = true;
            }
          }
        }

        if (show === true) {
          field.classList.add('active');
        } else {
          field.classList.remove('active');
        }
      });
    },
  },

  mounted() {
    // Load external JavaScript when component is mounted
    // import('utils/form.js').then((formScript) => {
    //   formScript.initForm(this.$el);
    // });

    const params = new URLSearchParams(window.location.search);
    var type = params.get("type");

    if (type == 'meeting_room')
      type = 8;
    else if (type == 'space')
      type = 5;
    else
      type = null;

    if (type) {
      this.form.cf_68 = type;
    }

    const select = this.$el.querySelector("select[class*='subject-select']");
    if (select) {
      select.addEventListener("change", this.handleSelectChange);

      if (type) {
      //   this.selectedOption = type;
        select.value = type;
      }

      // run once on load
      this.handleSelectChange({ target: select });
    }
  },
};
</script>

<template>
  <form
    id="se-webform-8"
    method="post"
    target="_self"
    action="https://app.smartemailing.cz/public/web-forms-v2/display-form/668133-xsqqq68yps9wi1gngm4x9jvrna2c29z90q44vd74n0r1yskclsufcclv92f3zdpdlgmc21vbj1dm80cl55yterrgs0umhm42chtu"
    @submit.prevent="handleSubmit"
  >
    <div id="footer-contact" class="se-webform-inner">
      <div class="se-header">
        <h3 class="mb-6 txt-q">
          {{ useRoute().query.type === 'meeting_room' ? $t("form.want-to-be-contacted-meeting-room") : $t("form.want-to-be-contacted") }}
        </h3>
      </div>

      <div class="se-body flex lg:justify-center">
        <ul>
          <li class="lg:justify-center">
            <!--            <label for="frm-webFormHtmlRenderer-webFormForm-fields-df_name" class="se-label se-required">Křestní jméno</label>-->
            <input
              id="frm-webFormHtmlRenderer-webFormForm-fields-df_name"
              class="footer-input block !bg-transparent !placeholder-black mb-4 py-2 lg:pl-6 pr-3 !shadow-sm focus:outline-none focus:ring-transparent focus:ring-1 sm:text-sm"
              :placeholder="$t('form.name')"
              type="text"
              name="fields[df_name]"
              v-model="form.df_name"
              data-nette-rules='[{"op":":filled","msg":"Křestní jméno je povinné pole"}]'
            />
            <div v-if="errors.df_name" class="text-red-500 text-sm mt-1 mb-6">
              {{ errors.df_name }}
            </div>
          </li>
          <li class="lg:justify-center">
            <!--            <label for="frm-webFormHtmlRenderer-webFormForm-fields-df_surname" class="se-label ">Příjmení</label>-->
            <input
              id="frm-webFormHtmlRenderer-webFormForm-fields-df_surname"
              class="footer-input block !bg-transparent !placeholder-black mb-4 py-2 lg:pl-6 pr-3 !shadow-sm focus:outline-none focus:ring-transparent focus:ring-1 sm:text-sm"
              :placeholder="$t('form.surname')"
              type="text"
              name="fields[df_surname]"
              v-model="form.df_surname"
            />
            <div v-if="errors.df_surname" class="text-red-500 text-sm mt-1 mb-6">
              {{ errors.df_surname }}
            </div>
          </li>
          <li class="lg:justify-center">
            <!--            <label for="frm-webFormHtmlRenderer-webFormForm-fields-df_phone" class="se-label ">Telefon</label>-->
            <input
              id="frm-webFormHtmlRenderer-webFormForm-fields-df_phone"
              class="footer-input block !bg-transparent !placeholder-black mb-4 py-2 lg:pl-6 pr-3 !shadow-sm focus:outline-none focus:ring-transparent focus:ring-1 sm:text-sm"
              :placeholder="$t('form.phone')"
              type="text"
              name="fields[df_phone]"
              data-nette-rules='[{"op":":static","rules":[{"op":"SE20\\Validators\\TypesFormValidator::validatePhoneNumberWithPreprocessing","msg":"Prosím, vyplňte platný telefon ve formátu +XXXXXXXXXXX"}],"control":"fields[df_phone]","arg":true}]'
              v-model="form.df_phone"
            />
            <div v-if="errors.df_phone" class="text-red-500 text-sm mt-1 mb-6">
              {{ errors.df_phone }}
            </div>
          </li>
          <li class="lg:justify-center">
            <!--            <label for="frm-webFormHtmlRenderer-webFormForm-fields-df_emailaddress" class="se-label se-required">E-mail</label>-->
            <input
              id="frm-webFormHtmlRenderer-webFormForm-fields-df_emailaddress"
              class="footer-input block !bg-transparent !placeholder-black mb-4 py-2 lg:pl-6 pr-3 !shadow-sm focus:outline-none focus:ring-transparent focus:ring-1 focus:ring-sky-500 focus:ring-1 sm:text-sm"
              :placeholder="$t('form.email')"
              type="text"
              name="fields[df_emailaddress]"
              data-emailaddress="1"
              data-nette-rules='[{"op":":filled","msg":"E-mailová adresa je povinné pole."},{"op":":email","msg":"E-mailová adresa je povinné pole."},{"op":"SE20\\Validators\\TypesFormValidator::validateEmailAddress","msg":"E-mailová adresa je povinné pole."}]'
              v-model="form.df_emailaddress"
            />
            <div v-if="errors.df_emailaddress" class="text-red-500 text-sm mt-1 mb-6">
              {{ errors.df_emailaddress }}
            </div>
          </li>
          <li class="pt-6">
            <label
              for="frm-webFormHtmlRenderer-webFormForm-fields-cf_68"
              class="se-label lg:pl-6"
              >{{ $t("form.about") }}</label
            >
            <div class="mt-4 flex lg:justify-center">
              <select
                id="frm-webFormHtmlRenderer-webFormForm-fields-cf_68"
                class="subject-select footer-input block !bg-transparent mb-4 py-2 lg:pl-6 pr-3 !shadow-sm focus:outline-none focus:ring-transparent focus:ring-1 sm:text-sm"
                name="fields[cf_68]"
                v-model="form.cf_68"
              >
                <option value="2">{{ $t("form.about.membership") }}</option>
                <option value="5">{{ $t("form.about.rent-space") }}</option>
                <option value="8">{{ $t("form.about.room-rental") }}</option>
              </select>
              <div v-if="errors.cf_68" class="text-red-500 text-sm mt-1 mb-6">
                {{ errors.cf_68 }}
              </div>
            </div>
          </li>
          <li class="lg:justify-center" data-show-on="5">
            <input
              type="text"
              name="fields[cf_129]"
              v-model="form.cf_129"
              id="frm-webFormHtmlRenderer-webFormForm-fields-cf_129"
              class="footer-input block !bg-transparent !placeholder-black mb-4 py-2 lg:pl-6 pr-3 !shadow-sm focus:outline-none focus:ring-transparent focus:ring-1 sm:text-sm"
              :placeholder="$t('form.event_name')"
            >
            <div v-if="errors.cf_129" class="text-red-500 text-sm mt-1 mb-6">
              {{ errors.cf_129 }}
            </div>
          </li>
          <li class="lg:justify-center" data-show-on="5">
            <input
              type="number"
              name="fields[cf_135]"
              v-model="form.cf_135"
              id="frm-webFormHtmlRenderer-webFormForm-fields-cf_135" data-nette-rules='[{"op":":filled","rules":[{"op":":float","msg":"Zadejte prosím platné číslo"}],"control":"fields[cf_135]"}]'
              class="footer-input block !bg-transparent !placeholder-black mb-4 py-2 lg:pl-6 pr-3 !shadow-sm focus:outline-none focus:ring-transparent focus:ring-1 sm:text-sm"
              :placeholder="$t('form.number_of_guests')"
            >
            <div v-if="errors.cf_135" class="text-red-500 text-sm mt-1 mb-6">
              {{ errors.cf_135 }}
            </div>
          </li>
          <li class="lg:justify-center" data-show-on="5">
            <input
              type="text"
              name="fields[cf_132]"
              v-model="form.cf_132"
              id="frm-webFormHtmlRenderer-webFormForm-fields-cf_132"
              class="footer-input block !bg-transparent !placeholder-black mb-4 py-2 lg:pl-6 pr-3 !shadow-sm focus:outline-none focus:ring-transparent focus:ring-1 sm:text-sm"
              :placeholder="$t('form.event_length')"
            >
            <div v-if="errors.cf_132" class="text-red-500 text-sm mt-1 mb-6">
              {{ errors.cf_132 }}
            </div>
          </li>
          <li class="lg:justify-center" data-show-on="8">
            <select
              name="fields[cf_138]"
              v-model="form.cf_138"
              id="frm-webFormHtmlRenderer-webFormForm-fields-cf_138"
              class="footer-input block !bg-transparent mb-4 py-2 lg:pl-6 pr-3 !shadow-sm focus:outline-none focus:ring-transparent focus:ring-1 sm:text-sm"
              data-empty="41"
              :placeholder="$t('form.meeting_room')"
            >
              <option value="41" selected>{{ $t('form.meeting_room') }}</option>
              <option value="15">Viola (až 4 osoby)</option>
              <option value="9">Štenc (až 10 osob)</option>
              <option value="12">Maxmilián (až 6 osob)</option>
              <option value="18">Otakar (až 30 osob)</option>
              <option value="21">Amélie (až 6 osob)</option>
              <option value="24">Salvátor (až 20 osob)</option>
              <option value="43">Kavárna (až 30 osob)</option>
              <option value="46">Terasa (až 30 osob) - venkovní prostor</option>
              <option value="49">Atrium (až 50 osob) - venkovní prostor</option>
            </select>
            <div v-if="errors.cf_138" class="text-red-500 text-sm mt-1 mb-6">
              {{ errors.cf_138 }}
            </div>
          </li>
          <li class="lg:justify-center date-field-container" :data-placeholder="$t('form.event_date')" data-show-on="5|8">
            <!-- <label for="frm-webFormHtmlRenderer-webFormForm-fields-cf_126" class="se-label ">Datum akce</label> -->
            <input
              type="date"
              name="fields[cf_126]"
              v-model="form.cf_126"
              id="frm-webFormHtmlRenderer-webFormForm-fields-cf_126"
              class="footer-input se-datepicker block !bg-transparent !placeholder-black mb-4 py-2 lg:pl-6 pr-3 !shadow-sm focus:outline-none focus:ring-transparent focus:ring-1 sm:text-sm"
              :placeholder="$t('form.event_date')"
            >
            <div v-if="errors.cf_126" class="text-red-500 text-sm mt-1 mb-6">
              {{ errors.cf_126 }}
            </div>
          </li>
          <li class="lg:justify-center" data-show-on="8">
            <input
              type="text"
              name="fields[cf_141]"
              v-model="form.cf_141"
              id="frm-webFormHtmlRenderer-webFormForm-fields-cf_141"
              class="footer-input block !bg-transparent !placeholder-black mb-4 py-2 lg:pl-6 pr-3 !shadow-sm focus:outline-none focus:ring-transparent focus:ring-1 sm:text-sm"
              :placeholder="$t('form.meeting_room_time')"
              data-empty="0"
            >
            <div v-if="errors.cf_141" class="text-red-500 text-sm mt-1 mb-6">
              {{ errors.cf_141 }}
            </div>
          </li>
          <li class="lg:justify-center" data-show-on="8">
            <select
              name="fields[cf_144]"
              v-model="form.cf_144"
              id="frm-webFormHtmlRenderer-webFormForm-fields-cf_144"
              class="footer-input block !bg-transparent mb-4 py-2 lg:pl-6 pr-3 !shadow-sm focus:outline-none focus:ring-transparent focus:ring-1 sm:text-sm"
              data-empty="38"
            >
              <option value="38">{{ $t("form.meeting_room_hours") }}</option>
              <option value="27">{{ $t("form.meeting_room_hours_1") }}</option>
              <option value="30">{{ $t("form.meeting_room_hours_2") }}</option>
              <option value="33">{{ $t("form.meeting_room_hours_3") }}</option>
              <option value="36">{{ $t("form.meeting_room_hours_4") }}</option>
            </select>
            <div v-if="errors.cf_144" class="text-red-500 text-sm mt-1 mb-6">
              {{ errors.cf_144 }}
            </div>
          </li>
          <li class="lg:justify-center">
            <input
              type="text"
              name="fields[cf_62]"
              v-model="form.cf_62"
              id="frm-webFormHtmlRenderer-webFormForm-fields-cf_62"
              class="footer-input block !bg-transparent !placeholder-black mb-4 py-2 lg:pl-6 pr-3 !shadow-sm focus:outline-none focus:ring-transparent focus:ring-1 sm:text-sm"
              :placeholder="$t('form.note')"
            >
            <div v-if="errors.cf_62" class="text-red-500 text-sm mt-1 mb-6">
              {{ errors.cf_62 }}
            </div>
          </li>

          <li class="se-webform-primary-purpose pt-6 pb-12 lg:px-6">
            <span
              >{{ $t("footer.newsletter.gdpr.part1") }}
              <a
                :href="
                  $i18n.locale === 'cs'
                    ? '../Zásadyzpracováníosobníchúdajů.pdf'
                    : '../Opero-Privacy-Policy.pdf'
                "
                target="_blank"
                rel="noopener noreferrer"
                >{{ $t("footer.newsletter.gdpr.part2") }}</a
              ></span
            >
          </li>
        </ul>
      </div>

      <div class="se-submit flex lg:justify-center">
        <button
          class="bg-transparent border rounded-full border-black text-black px-4 py-2"
          type="submit"
          name="_submit"
          value="Odeslat formulář"
        >
          {{ $t("form.submit") }}
        </button>
      </div>
    </div>

    <input id="se-ref-field-id" type="hidden" name="referrer" value="" /><input
      id="se-sessionid-field"
      type="hidden"
      name="sessionid"
      value=""
    /><input
      id="se-sessionUid-field"
      type="hidden"
      name="sessionUid"
      value=""
    /><input
      type="hidden"
      name="_do"
      value="webFormHtmlRenderer-webFormForm-submit"
    />
  </form>
</template>

<style scoped lang="scss">
#se-webform-5.se-webform {
  background: unset;
}
ul {
  max-width: 590px;
}

.footer-input {
  border-bottom: 1px solid rgba(0, 0, 0, 0.4);
  width: 590px;

  @media screen and (max-width: 768px) {
    //width: 450px;
    width: 100%;
  }
  //@media screen and (max-width: 530px) {
  //  width: 350px;
  //}
  //@media screen and (max-width: 430px) {
  //  width: 100%;
  //}
}

.date-field-container {
  position: relative;

  &::before {
    position: absolute;
    top: 9px;
    left: 25px;
    content: attr(data-placeholder);
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  input {
    padding-left: 130px;
  }
}

[data-show-on]:not(.active) {
  display: none;
}
</style>
